import QualityChangeService from '../../../core/QualityChangeService';
import {Event} from '../../../enums/Event';
import {EventCallbackDispatcher} from '../../internal/EventCallbackDispatcher';
import {PlayerContext} from '../player/AmazonIVSPlayerContext';

enum StartupState {
  SETUP,
  IDLE,
  STARTUP,
  STARTUP_FINISHED,
}

export class VideoStartupService {
  constructor(
    private dispatcher: EventCallbackDispatcher,
    private playerContext: PlayerContext,
    private qualityChangeService: QualityChangeService,
  ) {}

  private state: StartupState = StartupState.SETUP;

  get finishedStartup(): boolean {
    return this.state == StartupState.STARTUP_FINISHED;
  }

  onInitialized() {
    this.finishSetup();
  }

  onPlay() {
    this.startStartup();
  }

  onPlaying() {
    this.finishStartup();
  }

  private finishSetup() {
    this.state = StartupState.IDLE;
    const currentTime = this.playerContext.position;
    this.dispatcher.eventCallback(Event.READY, {
      currentTime,
    });
  }

  private startStartup() {
    if (this.state != StartupState.IDLE) {
      return;
    }

    this.state = StartupState.STARTUP;
    const currentTime = this.playerContext.position;
    this.dispatcher.eventCallback(Event.PLAY, {
      currentTime,
    });
  }

  private finishStartup() {
    if (this.state != StartupState.STARTUP) {
      return;
    }

    this.state = StartupState.STARTUP_FINISHED;
    const currentTime = this.playerContext.position;
    this.dispatcher.eventCallback(Event.PLAYING, {
      currentTime,
    });

    this.qualityChangeService.resetValues();
    // pass undefined for both video and audio bitrate.
    // Why? The quality change logic in this collector was written before these args have been introduced, and the logic
    // is built in a way that the first quality change event after the startup should set them for the first time.
    //
    // Maybe in the future, we can think about setting these values already here (if available). Or completely delete
    // the usage of quality service here, as I don't think this is a place where such 'reset' or startup marking logic
    // should be (because it is done by analytics module when the startup sample is sent)
    this.qualityChangeService.setStartupHasFinished(undefined, undefined);
  }
}
